import React from 'react';
import { useIntl } from 'react-intl';
import { messages } from './messages';
import { TopicNavContainer } from './TopicNavContainer';
import { TopicNavItem } from './TopicNavItem';
import { TopicNavSection } from './TopicNavSection';
import { buildTopicNavHref, deriveTopicNavState, isActiveSelection, } from './topicNavRouting';
import { useTopicNavConfig } from './useTopicNavConfig';
var expandSideMenuTray = function () {
    var _a;
    (_a = document
        .querySelector('[data-testid="ds-header-hamburger-action"]')) === null || _a === void 0 ? void 0 : _a.click();
};
var buildItem = function (_a, currentNavState, navItemClickHandler) {
    var Icon = _a.Icon, category = _a.category, label = _a.label;
    var onClick = function () { return navItemClickHandler(label, category); };
    var active = isActiveSelection(category, currentNavState);
    var href = buildTopicNavHref(category, currentNavState);
    if (href === undefined)
        return null;
    return (React.createElement(TopicNavItem, { key: href, href: href, label: label, active: active, Icon: Icon, onClick: onClick }));
};
export function TopicNav(_a) {
    var location = _a.location, navItemClickHandler = _a.navItemClickHandler;
    var intl = useIntl();
    var config = useTopicNavConfig();
    var navState = deriveTopicNavState(location, config);
    return (React.createElement(TopicNavContainer, null,
        React.createElement(TopicNavSection, { heading: intl.formatMessage(messages.seeAllTopics), href: "/shop" }, config.topics.map(function (topic) {
            return buildItem(topic, navState, navItemClickHandler);
        })),
        React.createElement(TopicNavSection, { heading: intl.formatMessage(messages.seeAllProducts), onHeadingClick: expandSideMenuTray }, config.products.map(function (product) {
            return buildItem(product, navState, navItemClickHandler);
        }))));
}
